var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',_vm._l((_vm.images),function(item,i){return _c('b-col',{key:i,staticClass:"mb-4",attrs:{"cols":2}},[_c('b-img',{class:_vm.classNames(item),style:({ cursor: 'pointer' }),attrs:{"src":item.image_small,"fluid":"","alt":item.title},on:{"click":function($event){return _vm.selectImage(item)}}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }